/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bizbank": {
        "nested": {
          "cards": {
            "nested": {
              "CardType": {
                "values": {
                  "CARD_TYPE_DO_NOT_USE": 0,
                  "PHYSICAL": 1,
                  "VIRTUAL": 2,
                  "PAIR": 3
                }
              },
              "CardBrand": {
                "values": {
                  "CARD_BRAND_DO_NOT_USE": 0,
                  "MASTERCARD": 1,
                  "VISA": 2,
                  "AMEX": 3
                }
              },
              "CardStatus": {
                "values": {
                  "CARD_STATUS_DO_NOT_USE": 0,
                  "UNACTIVATED": 1,
                  "ACTIVE": 2,
                  "DISABLED": 3,
                  "SUSPENDED": 4,
                  "TERMINATED": 5,
                  "ORDERED": 6
                }
              },
              "CardFulfillment": {
                "nested": {
                  "FulfillmentStatus": {
                    "values": {
                      "FULFILLMENT_STATUS_DO_NOT_USE": 0,
                      "PROCESSING": 1,
                      "SHIPPED": 2,
                      "DELIVERED": 3,
                      "FAILURE": 4,
                      "CANCELED": 5,
                      "REJECTED": 6
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bizbank?.nested?.cards?.nested?.CardType && !$root.nested?.squareup?.nested?.bizbank?.nested?.cards?.nested?.CardBrand && !$root.nested?.squareup?.nested?.bizbank?.nested?.cards?.nested?.CardStatus && !$root.nested?.squareup?.nested?.bizbank?.nested?.cards?.nested?.CardFulfillment?.nested?.FulfillmentStatus) {
  $root.addJSON(jsonData);
}

/**
 * ******* Card Resources ********
 *
 * SOURCE CardType @ squareup/bizbank/card.proto at 51:1
 */
export const CardType = $root.lookupEnum('squareup.bizbank.cards.CardType').values;
/**
 * SOURCE CardBrand @ squareup/bizbank/card.proto at 58:1
 */
export const CardBrand = $root.lookupEnum('squareup.bizbank.cards.CardBrand').values;
/**
 * SOURCE CardStatus @ squareup/bizbank/card.proto at 65:1
 */
export const CardStatus = $root.lookupEnum('squareup.bizbank.cards.CardStatus').values;
/**
 * SOURCE CardFulfillment @ squareup/bizbank/card.proto at 99:1
 */
export const CardFulfillment = {};
/**
 * SOURCE FulfillmentStatus @ squareup/bizbank/card.proto at 100:3
 */
CardFulfillment.FulfillmentStatus = $root.lookupEnum('squareup.bizbank.cards.CardFulfillment.FulfillmentStatus').values;